(function () {
  'use strict';

  function initConsent(container) {
    if (container.dataset.consentInit) return;
    container.dataset.consentInit = 'true';

    var form = container.closest('form');
    if (!form) return;

    var checkbox = container.querySelector('[data-newsletter-consent-checkbox]');
    var errorMsg = container.querySelector('[data-newsletter-consent-error]');
    var errorText = container.dataset.errorMessage || '';

    if (!checkbox) return;

    form.addEventListener(
      'submit',
      function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (errorMsg) {
            errorMsg.textContent = errorText;
            errorMsg.style.display = 'block';
          }
          checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      },
      true
    );

    checkbox.addEventListener('change', function () {
      if (errorMsg) errorMsg.style.display = 'none';
    });
  }

  function initAll() {
    document.querySelectorAll('[data-newsletter-consent]').forEach(initConsent);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target
      : document;
    section.querySelectorAll('[data-newsletter-consent]').forEach(initConsent);
  });
})();
